<template>
  <div class="row">
		<SideMenu/>
			<div class="right-column">
				<TopBar/>
				<main class="main-content p-5" role="main">
					<div class="row">
						<div class="col-md-12">
							<h1>Configuración</h1>
						</div>
					</div>
					<div class="row mb-4">
						<div class="col-md-12">
							<div class="card">
								<div class="card-header">Sucursal</div>
								<div class="card-body">
									<div class="row" v-if="isSucursalLoaded">
									<div class="col-8">
										<p>
											{{ sucursal.nombre }}
										</p>
									</div>
									<div class="col-4">
										<button class="btn btn-danger float-right mb-0" @click="changeSucursal">Cambiar Sucursal</button>
									</div>
									</div>
									<div class="row" v-else>
									<div class="col-8">
										<p>
											No se ha cargado ninguna sucursal, puedes cargar una a continuación.
										</p>
										<input type="file" id="file-selector" accept=".json">
									</div>
									<div class="col-4">
										<button class="btn btn-secondary float-right mb-0" @click="uploadSucursal">Subir Sucursal</button>
									</div>
									</div>
									
								</div>
							</div>
						</div>
					</div>
					<div class="row mb-4">
						<div class="col-md-12">
							<div class="card">
								<div class="card-header">Soporte</div>
								<div class="card-body">
									<p>
										¿Tienes dudas, sugerencias o algun problema? te atendemos en el numero 618 138 68 16
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="row mb-4">
						<div class="col-md-12">
							<footer>
								Powered by - <a href="http://base5builder.com/?click_source=quillpro_footer_link" target="_blank" style="font-weight:300;color:#ffffff;background:#1d1d1d;padding:0 3px;">Base<span style="color:#ffa733;font-weight:bold">5</span>Builder</a>
							</footer>
						</div>
					</div>
				</main>
			</div>
		</div>
</template>

<script>
// @ is an alias to /src
import SideMenu from '@/components/SideMenu.vue';
import TopBar from '@/components/TopBar.vue';
import Sucursal from "@/modules/restaurant/models/Sucursal.js";

export default {
  name: 'demo',
  components: {
	  SideMenu,
	  TopBar,
  },
  data(){
	  return {
		sucursal: null
	  }
  },
  mounted(){
	  this.sucursal = Sucursal.getSucursal()
  },
  methods: {
	  uploadSucursal(){
		const fileSelector = document.getElementById('file-selector');
		var File = fileSelector.files[0]
		if(!File){
			// Mensaje de Error
			console.log("error file")
			return;
		}
		Sucursal.setSucursal(File, this.updateSucursal)
	  },
	  changeSucursal(){
		  Sucursal.clearSucursal()
		  this.sucursal = null
	  },
	  updateSucursal(){
		  this.sucursal = Sucursal.getSucursal()
	  }
  },
  computed: {
	  isSucursalLoaded(){
		return this.sucursal != null
	  },
  }
};
</script>
